import React from "react";
import UploadProgressBar, { type UploadItem } from "./upload-progress-bar";

interface UploadProgressBarsProps {
	cultureCode: string;
	uploads: UploadItem[];
	onClickRemove: (attachmentId: string | undefined) => void;
}

export default function UploadProgressBars({
	uploads,
	cultureCode,
	onClickRemove,
}: UploadProgressBarsProps) {
	const style = uploads.length === 0 ? { display: "none" } : {};

	return (
		<div className="if grid across" style={style}>
			<div className="if row">
				<div className="if col-6--sm">
					{uploads.map((upload) => (
						<UploadProgressBar
							cultureCode={cultureCode}
							upload={upload}
							key={upload.id}
							onClickRemove={() => onClickRemove(upload.id)}
						/>
					))}
				</div>
			</div>
		</div>
	);
}
